module.exports = __webpack_public_path__ + "Icon_Organization Job Structure.be35ab1f16a092e85b67.png";